import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function ExpiringRentEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={PropertyIcon}
      title={Trans(
        translations,
        'HereYouWillSeeRentalAgreementsThatAreAboutToEnd'
      )}
      description={Trans(
        translations,
        'YouCanRegisterARentalByIndicatingItsDuration'
      )}
    />
  );
}

export default ExpiringRentEmptyState;
